module.exports = __webpack_public_path__ + "assets/img/25_409_big.5cd73496.jpg";